// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-icon {
  display: none;
  width: 30px;
  height: 4px;
  background-color: #434C63;
  transition: all 0.3s ease-in-out;
}

.menu-icon::before,
.menu-icon::after {
  content: '';
  display: block;
  width: 30px;
  height: 4px;
  background-color: #434C63;
  transition: all 0.3s ease-in-out;
}

.menu-icon::before {
  transform: translateY(-9px);
}

.menu-icon::after {
  transform: translateY(5px);
}

.menu-btn {
  margin-right: 2em;
  padding: 0 0 0 25px;
  display: block;
  border: none;
  background-color: #FFFFFF;
}

.menu-btn:hover {
  cursor: pointer;
}

.menu-block {
  display: none;
}

.menu-block.active-block {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 999;
  width: 100%;
  min-height: 100vh;
  background-color: #FFFFFF;
}

.menu-block.disable-block {
  display: none;
}

@media screen  and (max-width: 1050px) {

  .menu-icon{
    display: block;
  }
  .menu-btn {
    display: block;
  }

  .menu-icon.open {
    background-color: transparent;
  }

  .menu-icon.open::before {
    transform: rotate(45deg) translate(0px, 0px);
  }

  .menu-icon.open::after {
    transform: rotate(-45deg) translate(4px, -2px);
  }

}

`, "",{"version":3,"sources":["webpack://./src/components/MenuButton/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,8CAA8C;EAChD;;AAEF","sourcesContent":[".menu-icon {\n  display: none;\n  width: 30px;\n  height: 4px;\n  background-color: #434C63;\n  transition: all 0.3s ease-in-out;\n}\n\n.menu-icon::before,\n.menu-icon::after {\n  content: '';\n  display: block;\n  width: 30px;\n  height: 4px;\n  background-color: #434C63;\n  transition: all 0.3s ease-in-out;\n}\n\n.menu-icon::before {\n  transform: translateY(-9px);\n}\n\n.menu-icon::after {\n  transform: translateY(5px);\n}\n\n.menu-btn {\n  margin-right: 2em;\n  padding: 0 0 0 25px;\n  display: block;\n  border: none;\n  background-color: #FFFFFF;\n}\n\n.menu-btn:hover {\n  cursor: pointer;\n}\n\n.menu-block {\n  display: none;\n}\n\n.menu-block.active-block {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  min-height: 100vh;\n  background-color: #FFFFFF;\n}\n\n.menu-block.disable-block {\n  display: none;\n}\n\n@media screen  and (max-width: 1050px) {\n\n  .menu-icon{\n    display: block;\n  }\n  .menu-btn {\n    display: block;\n  }\n\n  .menu-icon.open {\n    background-color: transparent;\n  }\n\n  .menu-icon.open::before {\n    transform: rotate(45deg) translate(0px, 0px);\n  }\n\n  .menu-icon.open::after {\n    transform: rotate(-45deg) translate(4px, -2px);\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
